import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["columns"];
import styled from 'styled-components';
import I18n from 'I18n';
import { GREAT_WHITE, GYPSUM, OLAF, OZ } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIBreakString from 'UIComponents/text/UIBreakString';
import UITable from 'UIComponents/table/UITable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GradientOverlay = styled.div.withConfig({
  displayName: "SharedComponents__GradientOverlay",
  componentId: "sc-16osffv-0"
})(["position:relative;overflow:hidden;max-height:", ";&::after{visibility:", ";opacity:", ";position:absolute;bottom:0;height:100%;width:100%;content:'';background:linear-gradient(to bottom,transparent 70%,", ");pointer-events:none;}"], props => props.expanded ? '100%' : '650px', props => props.expanded ? 'hidden' : 'visible', props => props.expanded ? 0 : 1, OLAF);

/**
 * If we have a table with table-layout: fixed, we can make all columns
 * equal width by including this before the <thead>
 *
 * @param columns - number of columns in table
 */
export const Colgroup = styled(props => {
  const {
      columns
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const cols = [];
  for (let i = 0; i < columns; i++) {
    cols.push( /*#__PURE__*/_jsx("col", {}, `col-${i}`));
  }
  return /*#__PURE__*/_jsx("colgroup", Object.assign({}, rest, {
    children: cols
  }));
}).withConfig({
  displayName: "SharedComponents__Colgroup",
  componentId: "sc-16osffv-1"
})(["& col{width:", "%;}"], props => 100 / props.columns);
export const THead = styled.thead.withConfig({
  displayName: "SharedComponents__THead",
  componentId: "sc-16osffv-2"
})(["tr{position:relative;}& tr::after{content:'';position:absolute;bottom:0;left:0;right:0;border:1px solid transparent;box-shadow:0 2px 4px ", ";}& tr th{background-color:transparent;border:none;font-size:0.875rem;text-transform:inherit;text-align:center;font-weight:600;white-space:nowrap;padding-top:12px;padding-bottom:8px;position:relative;", "}& tr th:first-of-type{font-size:1.5rem;text-align:left;line-height:100%;vertical-align:", ";}& h2:first-of-type{font-weight:600;}"], GREAT_WHITE, props => props.verticalAlign && `vertical-align: ${props.verticalAlign};`, props => props.verticalAlign || 'text-top');
export const TBody = styled.tbody.withConfig({
  displayName: "SharedComponents__TBody",
  componentId: "sc-16osffv-3"
})(["", " & tr td{text-align:center;}& tr th[scope='row']{text-align:left;padding:16px 24px;}", ""], props => props.bordered && `
  & tr > * {
    border: 1px solid ${GREAT_WHITE};
  }

    `, props => {
  const {
    variant
  } = props;
  switch (variant) {
    case 'alternating':
      return `
          tr {
            border-style: hidden;
          }
          tr:nth-child(even) {
            background-color: ${OLAF};
          }
          tr:nth-child(odd) {
            background-color: ${GYPSUM};
          }
        `;
    default:
      return undefined;
  }
});
TBody.defaultProps = {
  bordered: true
};
export const FeatureAvailableIcon = ({
  iconProps
}) => {
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(UIIconCircle, Object.assign({
      name: "success",
      color: OLAF,
      backgroundColor: OZ,
      borderWidth: 0,
      size: 8
    }, iconProps)), /*#__PURE__*/_jsx("span", {
      className: "sr-only",
      children: I18n.text('compare.screenReader.featureAvailable')
    })]
  });
};
export const FeatureUnavailableIcon = () => {
  return /*#__PURE__*/_jsx(UIIcon, {
    name: "minus",
    size: "xxs",
    screenReaderText: I18n.text('compare.screenReader.featureUnavailable')
  });
};
export const StyledBreakString = styled(UIBreakString).withConfig({
  displayName: "SharedComponents__StyledBreakString",
  componentId: "sc-16osffv-4"
})(["word-wrap:break-word;white-space:pre-wrap;"]);
export const FixedTableLayout = styled(UITable).withConfig({
  displayName: "SharedComponents__FixedTableLayout",
  componentId: "sc-16osffv-5"
})(["display:table;table-layout:fixed;width:100%;overflow-x:hidden;"]);